import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function Timeline() {
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/timeline/story");
        setStory(data);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="space-y-3"><Skeleton className="h-8 w-40" /><Skeleton className="h-40 w-full" /></div>;

  const years = story?.years || [];

  return (
    <div className="space-y-8" data-testid="timeline-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Your health story</h1>
        {story?.intro && <p className="text-neutral-700 mt-3 text-lg leading-relaxed max-w-3xl">{story.intro}</p>}
      </div>

      {years.length === 0 && (
        <div className="text-neutral-500 text-sm">No history yet. Add a record to start your story.</div>
      )}

      {years.map((y) => (
        <section key={y.year} className="border-l-2 border-neutral-200 pl-6" data-testid={`year-${y.year}`}>
          <h2 className="text-2xl font-semibold -ml-[26px] bg-neutral-50 inline-block px-2">{y.year}</h2>
          {y.headline && <p className="text-neutral-800 mt-3 leading-relaxed">{y.headline}</p>}
          {y.highlights?.length > 0 && (
            <ul className="mt-3 space-y-2">
              {y.highlights.map((h, i) => (
                <li key={i} className="text-sm text-neutral-700">
                  <span className="text-neutral-500">{h.date || y.year}</span> — <span className="font-medium">{h.title}</span>
                  {h.body ? <span className="text-neutral-600"> {h.body}</span> : null}
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
